var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-breadcrumbs',{staticClass:"pa-0 mb-2",attrs:{"items":_vm.breadcrumbsItems,"large":""}}),_c('Resource',{attrs:{"resourceRes":_vm.resources}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }